import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import ReactOnRails from 'react-on-rails-pro/client';

import EatApp from '../eat/EatApp';
import onRecoverableError from '../utils/onRecoverableError';

const App = (props, railsContext, domNodeId) => {
  hydrateRoot(
    document.getElementById(domNodeId),
    React.createElement(
      EatApp,
      props,
    ),
    { onRecoverableError },
  );
};

ReactOnRails.register({
  EatApp: App,
});
